import React from "react";
import Chart from "react-apexcharts";
import { Card, CardContent } from "@mui/material";

export default function ReportsLiveChart({ months, chartValue }) {
  const labels = Array.isArray(months) && months.length > 0 ? months : [];
  const raw = Array.isArray(chartValue) ? chartValue.map((v) => Number(v) || 0) : [];
  const data = raw.length > 0 ? raw : [0];
  const vmin = Math.min(...data);
  const vmax = Math.max(...data);
  let yMin = vmin;
  let yMax = vmax;
  if (yMax === yMin) {
    yMax = yMin + 10;
    yMin = Math.max(0, yMin - 2);
  } else {
    const pad = (yMax - yMin) * 0.1 || 1;
    yMin = Math.max(0, yMin - pad);
    yMax = yMax + pad;
  }

  const chartOptions = {
    chart: {
      type: "area",
      toolbar: { show: false },
    },
    xaxis: {
      categories: labels.length > 0 ? labels : data.map((_, i) => String(i + 1)),
      labels: {
        style: { colors: "#787878", fontSize: "14px" },
      },
    },
    yaxis: {
      min: yMin,
      max: yMax,
      labels: {
        style: { colors: "#787878", fontSize: "14px" },
      },
    },
    stroke: {
      curve: "smooth",
      width: 3,
      colors: ["#6A0DAD"],
    },
    fill: {
      type: "solid",
      colors: ["#6A0DAD"],
      opacity: 0.15,
    },
    grid: {
      borderColor: "#EAEAEA",
      strokeDashArray: 5,
    },
    dataLabels: {
      enabled: false,
    },
  };

  const chartSeries = [
    {
      name: "Occupied (month overlap count)",
      data,
    },
  ];

  return (
    <Card sx={{ p: 2, borderRadius: "12px" }}>
      <CardContent>
        <Chart
          options={chartOptions}
          series={chartSeries}
          type="area"
          height={300}
        />
      </CardContent>
    </Card>
  );
}
